import axios from 'axios';
import serviceHelper from '../../helpers/functions/service.helper';

async function getPark(query){
    const queryString = serviceHelper.queryString(query);
    const parkResponse = await axios.get(`config/park?${queryString}`, { withCredentials : true });
    return parkResponse?.data;
}

export default {
    getPark,
}